import { pick } from 'lodash';
import { parse, stringify } from 'query-string';

const validParams = ['v', 'ft'];

export const filterQueryParams = (search: string) => {
  const params = parse(search);
  const filteredParams = pick(params, validParams);

  return stringify(filteredParams);
};
